export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const SOCKET_BASE_API_URL = process.env.REACT_APP_VOL2_BASE_URL;
export const AI_BASE_URL = process.env.REACT_APP_AI_URL;

// export const MEDIA_URL = "https://beemzbucket.s3.amazonaws.com/uploads/images/";
// export const USER_DOCUMENTS_URL =
//   "https://beemzbucket.s3.amazonaws.com/uploads/files/";
// export const IMAGE_URL = "https://beemzbucket.s3.amazonaws.com/images/";
// export const VIDEO_URL =
//   "https://beemzbucket.s3.amazonaws.com/uploads/attachments/";
//   export const AUDIO_URL =
//   "https://beemzbucket.s3.amazonaws.com/uploads/audio/";
// export const VIDEO_URL2 = "https://beemzbucket.s3.amazonaws.com/uploads/video/";
// export const THUMP_URL =
//   "https://beemzbucket.s3.amazonaws.com/uploads/attachments/thumb/";
// export const BUSINESS_DOCUMENTS_URL =
//   "https://beemzbucket.s3.us-east-1.amazonaws.com/business-documents/";
// export const CATEGORY_ICONS_BASE_URL =
//   "https://beemzbucket.s3.us-east-1.amazonaws.com/";

export const MEDIA_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/uploads/images/";
export const USER_DOCUMENTS_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/files/";
export const IMAGE_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/images/";
export const VIDEO_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/videos/";
export const AUDIO_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/audio/";
export const VIDEO_URL2 = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/video/";
export const THUMP_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/attachments/thumb/";
export const BUSINESS_DOCUMENTS_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/business-documents/";
export const CATEGORY_ICONS_BASE_URL = "https://beemzbucket-prod.s3.us-east-1.amazonaws.com/";

export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}/api/v1/user/login`,
    register: `${API_BASE_URL}/api/v1/user/register`,
    forgotPassword: `${API_BASE_URL}/api/v1/user/otp/get`,
    verifyOtp: `${API_BASE_URL}/api/v1/user/otp/verify`,
    resendOtp: `${API_BASE_URL}/api/v1/user/otp/resend`,
    resetPassword: `${API_BASE_URL}/api/v1/user/password/forgot`,
    me: `${API_BASE_URL}/api/v1/user/profile`,
    userInfo: (userID) => `${API_BASE_URL}/api/v1/user/info/${userID}`,
    fetchUsers: (users) =>
      `${API_BASE_URL}/api/v1/user/check-user-name-exist/${users}`,
  },

  COMMON: {
    group: `${API_BASE_URL}/api/v1/common/group`,
    user: `${API_BASE_URL}/api/v1/common/users`,
    business: `${API_BASE_URL}/api/v1/common/business`,
    country: `${API_BASE_URL}/api/v1/country/all`,
    getCountryFields: (countryCode) => `${API_BASE_URL}/api/v1/country/${countryCode}/fields`,
    foodType: `${API_BASE_URL}/api/v1/food-type`,
    dietType: `${API_BASE_URL}/api/v1/diet-type`,
    ingredient: `${API_BASE_URL}/api/v1/ingredient`,
    allergen: `${API_BASE_URL}/api/v1/allergens`,
    sides: `${API_BASE_URL}/api/v1/sides`,
    department: `${API_BASE_URL}/api/v1/department`,
    images: `${API_BASE_URL}/api/v1/common/images`,
    videos: `${API_BASE_URL}/api/v1/common/videos`,
    currency: `${API_BASE_URL}/api/v1/currency`,
    companyInfo: `${API_BASE_URL}/api/v1/admin/company-info`,
  },

  USER: {
    random: `${API_BASE_URL}/api/v1/user/random`,
    info: `${API_BASE_URL}/api/v1/user/info`,
    profileSetting: `${API_BASE_URL}/api/v1/user/permissions/setting`,
    editProfile: `${API_BASE_URL}/api/v1/user/edit-profile`,
    followUnfollow: `${API_BASE_URL}/api/v1/user/follow-unfollow`,
    followingList: `${API_BASE_URL}/api/v1/user/following`,
    followerList: `${API_BASE_URL}/api/v1/user/followers`,
    link_unlink_user: `${API_BASE_URL}/api/v1/user/linked-user`,
    getLinkedReq: `${API_BASE_URL}/api/v1/user/link-requests`,
    linkReqAction: `${API_BASE_URL}/api/v1/user/link-request-action`,
    getLinkedUsers: `${API_BASE_URL}/api/v1/user/linked-user`,
    nearbyPeople: `${API_BASE_URL}/api/v1/user/near-by-people`,
    locationGroups: `${API_BASE_URL}/api/v1/user/location/group`,
    getOtp: `${API_BASE_URL}/api/v1/user/otp/get`,
    verifyOtp: `${API_BASE_URL}/api/v1/user/otp/verify/signup`,
    homeAddress: `${API_BASE_URL}/api/v1/user/home/address`,
    idVerify: `${API_BASE_URL}/api/v1/user/id-verify`,
    childIdVerify: `${API_BASE_URL}/api/v1/user/child-id-verify`,
    documentUpload: `${API_BASE_URL}/api/v1/user/document-upload`,
    countryIds: `${API_BASE_URL}/api/v1/user/country-ids`,
    // Add new endpoints for ID verification
    minorVerification: `${API_BASE_URL}/api/v1/user/profile/document/minor`,
    adultVerification: `${API_BASE_URL}/api/v1/user/profile/document`,
    fileUpload: `${API_BASE_URL}/api/v1/user/upload/file`,
    multipleFileUpload: `${API_BASE_URL}/api/v1/user/multiple/file/upload`,
    referenceList: `${API_BASE_URL}/api/v1/user/references`,
    references: `${API_BASE_URL}/api/v1/user/references/all`,
    reference: `${API_BASE_URL}/api/v1/user/profile/reference`,
    referenceDelete: `${API_BASE_URL}/api/v1/user/reference/delete`,
    referenceAcceptReject: (requestId) =>
      `${API_BASE_URL}/api/v1/user/references/${requestId}`,
    createCheckoutSession: `${SOCKET_BASE_API_URL}/payment/make-payment`,
    block: `${API_BASE_URL}/api/v1/block/block`,
    unblock: `${API_BASE_URL}/api/v1/block/unblock`,
    getBlockedList: `${API_BASE_URL}/api/v1/block/blocked`,
    notificationCounts: `${API_BASE_URL}/api/v1/user/notification-counts`,
    inactive: `${API_BASE_URL}/api/v1/user/inactive`,
    deleteRequest: `${API_BASE_URL}/api/v1/user/delete/request`,
  },

  BUSINESS: {
    create: `${API_BASE_URL}/api/v1/business`,
    businessProfile: (businessId) =>
      `${API_BASE_URL}/api/v1/business/profile/${businessId}`,
    businessLocationProfile: (locationId) =>
      `${API_BASE_URL}/api/v1/business-location/profile/${locationId}`,
    category: `${API_BASE_URL}/api/v1/business/category`,
    userName: `${API_BASE_URL}/api/v1/business/user-name`,
    verifyOtp: `${API_BASE_URL}/api/v1/business/verify-otp`,
    resendOtp: `${API_BASE_URL}/api/v1/business/resend-otp`,
    uploadImage: `${API_BASE_URL}/api/v1/business/upload/image`,
    uploadDocument: `${API_BASE_URL}/api/v1/business/upload-document`,
    followerList: `${API_BASE_URL}/api/v1/business-location/followers`,
    subscriptionPlansList: `${API_BASE_URL}/api/v1/subscription-plan`,
    subscriptionPlans: `${API_BASE_URL}/api/v1/user-subscription`,
    createCheckoutSession: `${SOCKET_BASE_API_URL}/payment/make-payment`,
    getPublishKey: `${API_BASE_URL}/api/v1/payment/publish-key`,
    cancelSubscription: `${SOCKET_BASE_API_URL}/payment/cancel-subscription`,
    getALLBusinessFollowers: (businessId) =>
      `${API_BASE_URL}/api/v1/business/${businessId}/followers`,
    getBusinessInfoAboutSubscription: (businessId) =>
      `${API_BASE_URL}/api/v1/business/${businessId}/info-about-subscription`,
    getSubscriptionInvoices: (businessId) =>
      `${SOCKET_BASE_API_URL}/payment/subscription-invoices?businessId=${businessId}`,
    change: `${API_BASE_URL}/api/v1/business/change`,
    changeVerify: (businessId) =>
      `${API_BASE_URL}/api/v1/business/change/${businessId}`,
    requestReactivation: (businessId) =>
      `${API_BASE_URL}/api/v1/business/${businessId}/request-reactivation`,
  },

  BUSINESS_LOCATION: {
    add: `${API_BASE_URL}/api/v1/business-location`,
    getAll: `${API_BASE_URL}/api/v1/business-location`,
    setting: `${API_BASE_URL}/api/v1/business-location/setting`,
    chatCategories: `${API_BASE_URL}/api/v1/business-location/chat-categories`,
    delete: (locationId) =>
      `${API_BASE_URL}/api/v1/business-location/${locationId}`,
    businessFollowUnfollow: (locationId) =>
      `${API_BASE_URL}/api/v1/business-location/follow-unfollow/${locationId}`,
  },

  WALLET: {
    getByLocation: (locationId) =>
      `${API_BASE_URL}/api/v1/wallet/location/${locationId}`,
    getByCurrentBalance: (locationId, range) =>
      `${API_BASE_URL}/api/v1/wallet/current-balance/${range}/${locationId}`,
    cashOut: `${API_BASE_URL}/api/v1/cashout`,
    getLastCashOut: (locationId) =>
      `${API_BASE_URL}/api/v1/cashout/location/${locationId}`,
  },

  BANK_ACCOUNT: {
    create: `${API_BASE_URL}/api/v1/bank-account`,
    getCountryFields: (countryCode) => `${API_BASE_URL}/api/v1/bank-account/country/${countryCode}/fields`,
    getByLocation: (locationId) => `${API_BASE_URL}/api/v1/bank-account/business-location/${locationId}`,
    update: (accountId) => `${API_BASE_URL}/api/v1/bank-account/${accountId}`,
    delete: (accountId) => `${API_BASE_URL}/api/v1/bank-account/${accountId}`,
    deleteAttachment: (accountId, imageName) => `${API_BASE_URL}/api/v1/bank-account/${accountId}/attachment/${imageName}`,
  },

  EMPLOYEE: {
    getUnavailableList: `${API_BASE_URL}/api/v1/employee/unavailable/list`,
    getBusinesslinkReq: `${API_BASE_URL}/api/v1/employee/e/request-list`,
    getBusinesslinkReqAction: `${API_BASE_URL}/api/v1/employee/request/accept-reject`,
    leaveRequest: (businessId) => `${API_BASE_URL}/api/v1/leave/${businessId}`,
    businessLeaveRequest: (businessId) =>
      `${API_BASE_URL}/api/v1/leave/${businessId}/business-leave`,
    getLeaveRequest: (businessId) =>
      `${API_BASE_URL}/api/v1/leave/business/${businessId}`,
    leaveRequestAction: (requestId) =>
      `${API_BASE_URL}/api/v1/leave/${requestId}/status`,
    employeeLeaveRequestStatus: `${API_BASE_URL}/api/v1/leave/employee`,
    getEmployeeLocations: `${API_BASE_URL}/api/v1/employee/user-locations`,
    getFutureLeaveDates: (businessId, employeeId) =>
      `${API_BASE_URL}/api/v1/leave/${businessId}/employee/${employeeId}/future-dates`,
  },

  SOCIAL: {
    fetchFeeds: `${API_BASE_URL}/api/v1/feed-post/list`,
    getPost: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}`,
    getUserPosts: (userId) => `${API_BASE_URL}/api/v1/feed-post/user/${userId}`,
    createPost: `${API_BASE_URL}/api/v1/feed-post`,
    updatePost: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}`,
    deletePost: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}`,
    repost: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}/repost`,
    follow: `${API_BASE_URL}/api/v1/socials/user/follow`,
    like: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}/like`,
    getLikes: (postId) => `${API_BASE_URL}/api/v1/socials/post/like/${postId}`,
    uploadMedia: `${API_BASE_URL}/api/v1/socials/multiple/video/upload`,
  },

  Comment: {
    add: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}/comments`,
    get: (postId) => `${API_BASE_URL}/api/v1/feed-post/${postId}/comments`,
    delete: (postId, commentId) =>
      `${API_BASE_URL}/api/v1/feed-post/${postId}/comments/${commentId}`,
    deleteReply: (postId, commentId, replyId) =>
      `${API_BASE_URL}/api/v1/feed-post/${postId}/comments/${commentId}/replies/${replyId}`,
    like: (postId, commentId) =>
      `${API_BASE_URL}/api/v1/feed-post/${postId}/comments/${commentId}/like`,
    replyLike: (postId, commentId, replyId) =>
      `${API_BASE_URL}/api/v1/feed-post/${postId}/comments/${commentId}/replies/${replyId}/like`,
    replyComment: (postId, commentId) =>
      `${API_BASE_URL}/api/v1/feed-post/${postId}/comments/${commentId}/replies`,
  },

  TEAM_LINKING: {
    get: `${API_BASE_URL}/api/v1/user/linked-user`,
    getBemmzUser: `${API_BASE_URL}/api/v1/user/global-search`,
    get_followers: (businessId) =>
      `${API_BASE_URL}/api/v1/user/business-followers/${businessId}`,
    get_system_roles: `${API_BASE_URL}/api/v1/system-role`,
    get_business_locations: (businessId) =>
      `${API_BASE_URL}/api/v1/business-location/${businessId}`,
    link_team_member: (businessId, userId) =>
      `${API_BASE_URL}/api/v1/employee/e/${businessId}/${userId}`,
    update_team_member: (businessId, employeeId) =>
      `${API_BASE_URL}/api/v1/employee/e/${businessId}/${employeeId}`,
    get_managers: (businessId) =>
      `${API_BASE_URL}/api/v1/employee/e/member-list/${businessId}`,
    get_team_member: (businessId) =>
      `${API_BASE_URL}/api/v1/employee/e/member-list/${businessId}`,
    delete_team_member: (businessId, employeeId) =>
      `${API_BASE_URL}/api/v1/employee/e/${businessId}/${employeeId}`,
    send_team_invitation: `${API_BASE_URL}/api/v1/user/send-team-invitation`,
    update_order_flow: (locationId) =>
      `${API_BASE_URL}/api/v1/business-location/chat-order-settings/${locationId}`,
  },

  MENU: {
    get: `${API_BASE_URL}/api/v1/menu/business`,
    add: `${API_BASE_URL}/api/v1/menu`,
    getByLocation: (locationId) =>
      `${API_BASE_URL}/api/v1/menu/location/${locationId}`,
    bulkCreate: (businessId) => `${API_BASE_URL}/api/v1/menu/${businessId}/bulk`,
  },

  MENU_ITEM: {
    add: `${API_BASE_URL}/api/v1/menu-item`,
    get: `${API_BASE_URL}/api/v1/menu-item`,
    getItem: (itemId) => `${API_BASE_URL}/api/v1/menu-item/item/${itemId}`,
    getAll: `${API_BASE_URL}/api/v1/menu-item`,
    bulkCreate: (businessId) => `${API_BASE_URL}/api/v1/menu-item/${businessId}/bulk`,
  },

  MENU_CATEGORY: {
    get: `${API_BASE_URL}/api/v1/category`,
    add: `${API_BASE_URL}/api/v1/category`,
    delete: `${API_BASE_URL}/api/v1/category`,
    update: `${API_BASE_URL}/api/v1/category`,
    bulkCreate: (businessId) => `${API_BASE_URL}/api/v1/category/${businessId}/bulk`,
  },

  CHAT: {
    checkOneToOneExist: `${SOCKET_BASE_API_URL}/chat/check-single-conversation`,
    checkBusinessChatCategoryExist: `${SOCKET_BASE_API_URL}/chat/business-group`,
    chatCategories: `${SOCKET_BASE_API_URL}/chat/chat-categories/`,
    getChatCategoriesByLocation: (locationId) => `${SOCKET_BASE_API_URL}/chat/chat-categories/${locationId}`,
    getActiveChatCategories: (businessLocationId) => `${SOCKET_BASE_API_URL}/chat/active-chat-categories/${businessLocationId}`,
    getChatStatistics: (params) => {
      const baseUrl = `${SOCKET_BASE_API_URL}/chat/statistics`;
      const queryParams = new URLSearchParams();
      if (params.dateRange) queryParams.append('dateRange', params.dateRange);
      if (params.locationIds && params.locationIds.length > 0) {
        queryParams.append('locationIds', Array.isArray(params.locationIds) ? params.locationIds.join(',') : params.locationIds);
      }
      if (params.categoryId) queryParams.append('categoryId', params.categoryId);
      return `${baseUrl}?${queryParams.toString()}`;
    },
    createNestedChat: `${SOCKET_BASE_API_URL}/chat/create-nested`,
    createGroupConversation: `${SOCKET_BASE_API_URL}/chat/create-group`,
    updateGroup: (conversationId) => `${SOCKET_BASE_API_URL}/chat/update-group/${conversationId}`,
    subscriptionPlans: `${API_BASE_URL}/api/v1/user-subscription`,
    getNearbyPeople: `${SOCKET_BASE_API_URL}/chat/members`,
    getRequests: `${SOCKET_BASE_API_URL}/chat/requests`,
    acceptRequest: `${SOCKET_BASE_API_URL}/chat/accept-request`,
    rejectRequest: `${SOCKET_BASE_API_URL}/chat/reject-request`,
    enebleAI: (conversationId) =>
      `${SOCKET_BASE_API_URL}/chat/enable-ai-message/${conversationId}`,
    closeConvertion: (conversationId) =>
      `${SOCKET_BASE_API_URL}/chat/open-close-conversation/${conversationId}`,
    incrementAiRequestCount: `${SOCKET_BASE_API_URL}/chat/increment-ai-request-count`,
    getAiRequestCount: (businessLocationId) =>
      `${SOCKET_BASE_API_URL}/chat/ai-request-count/${businessLocationId}`,
    enableInAppWalletPayments: (locationId) =>
      `${SOCKET_BASE_API_URL}/chat/enable-in-app-wallet-payments/${locationId}`,
    sendManualPaymentMessage: `${SOCKET_BASE_API_URL}/chat/send-manual-payment-message`,
    getMiniConversationUnreadCount: (conversationId) =>
      `${SOCKET_BASE_API_URL}/chat/mini-conversation-unread-count/${conversationId}`,
    markMiniConversationAsRead: (conversationId) =>
      `${SOCKET_BASE_API_URL}/chat/mini-conversation-mark-as-read/${conversationId}`,
    ensureMember: `${SOCKET_BASE_API_URL}/chat/ensure-member-in-conversation`,
  },

  CONVERSATION: {
    addMembers: `${SOCKET_BASE_API_URL}/chat/add-members-request`,
    deleteMembersRequest: `${SOCKET_BASE_API_URL}/chat/delete-members-request`,
    addMemberToConversation: `${SOCKET_BASE_API_URL}/chat/add-member-to-conversation`,
    removeMember: `${SOCKET_BASE_API_URL}/chat/remove-group-member`,
    makeAdmin: `${SOCKET_BASE_API_URL}/chat/make-admin`,
    removeAdmin: `${SOCKET_BASE_API_URL}/chat/remove-admin`,
    getMedia: (conversationId, params = {}) => {
      const baseUrl = `${SOCKET_BASE_API_URL}/chat/media/${conversationId}`;
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      const queryString = queryParams.toString();
      return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    },
    exitFromGroup: (conversationId) => `${SOCKET_BASE_API_URL}/chat/exit-from-group/${conversationId}`,
    deleteConversations: `${SOCKET_BASE_API_URL}/chat/delete-conversations`,
    deleteConversation: (conversationId) => `${SOCKET_BASE_API_URL}/chat/delete-conversation/${conversationId}`,
    clearChat: `${SOCKET_BASE_API_URL}/chat/clear-chat`,
  },
  CART: {
    add: `${API_BASE_URL}/api/v1/cart`,
    get: `${API_BASE_URL}/api/v1/cart`,
    delete: `${API_BASE_URL}/api/v1/cart`,
  },

  ORDER: {
    place: `${SOCKET_BASE_API_URL}/order/place`,
    getOrderById: (orderId) => `${API_BASE_URL}/api/v1/order/${orderId}`,
    getOrderByNumber: (orderNumber, conversationId) => `${API_BASE_URL}/api/v1/order/by-number/${orderNumber}/${conversationId}`,
    getMyOrders: (params = {}) => {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.paymentStatus) queryParams.append('paymentStatus', params.paymentStatus);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.search) queryParams.append('search', params.search);
      const query = queryParams.toString();
      return `${SOCKET_BASE_API_URL}/order/my-orders${query ? `?${query}` : ''}`;
    },
    // initiatePayment: (orderId) => `${API_BASE_URL}/api/v1/order/${orderId}/payment/initiate`,
    // respondToPayment: (orderId) => `${API_BASE_URL}/api/v1/order/${orderId}/payment/respond`,
    getTeamOrders: (locationIds, params = {}) => {
      const baseUrl = `${API_BASE_URL}/api/v1/order/location/team-orders`;
      const locationIdsParam = Array.isArray(locationIds) 
        ? locationIds.join(',') 
        : locationIds;
      const queryParams = new URLSearchParams({
        locationIds: locationIdsParam,
        ...(params.page && { page: params.page }),
        ...(params.limit && { limit: params.limit }),
        ...(params.status && { status: params.status }),
      });
      return `${baseUrl}?${queryParams.toString()}`;
    },
    getTeamOrderById: (locationId, orderId) =>
      `${API_BASE_URL}/api/v1/order/location/${locationId}/team-orders/${orderId}`,
    getLocationItems: (locationIds, params = {}) => {
      const baseUrl = `${API_BASE_URL}/api/v1/order/location/items`;
      const locationIdsParam = Array.isArray(locationIds) 
        ? locationIds.join(',') 
        : locationIds;
      const queryParams = new URLSearchParams({
        locationIds: locationIdsParam,
      });
      
      // Add optional params
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.startTime) queryParams.append('startTime', params.startTime);
      if (params.endTime) queryParams.append('endTime', params.endTime);
      if (params.orderMode) queryParams.append('orderMode', params.orderMode);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
      
      // Handle itemStatus array
      if (params.itemStatus && Array.isArray(params.itemStatus)) {
        params.itemStatus.forEach(status => {
          queryParams.append('itemStatus', status);
        });
      }
      
      return `${baseUrl}?${queryParams.toString()}`;
    },
    updateItemStatus: (orderId, menuItemId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/item/${menuItemId}/status`,
    updateOrderStatus: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/status`,
    updateUserPaymentStatus: (orderId, userId) =>
      `${API_BASE_URL}/api/v1/order/${orderId}/user/${userId}/payment-status`,
    updatePaymentStatus: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/payment-status`,
    initiatePayment: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/payment/initiate`,
    respondToPayment: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/payment/respond`,
    processPayment: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/payment/process`,
    paymentResponse: (orderId) =>
      `${SOCKET_BASE_API_URL}/order/${orderId}/payment/response`,
    // cancelItems: (orderId) => `${API_BASE_URL}/api/v1/order/${orderId}/cancel-items`,
    cancelItems: (orderId) => `${SOCKET_BASE_API_URL}/order/${orderId}/cancel-items`,
    requestCancellation: (orderId) => `${SOCKET_BASE_API_URL}/order/${orderId}/request-cancellation`,
    handleCancellation: (orderId) => `${SOCKET_BASE_API_URL}/order/${orderId}/handle-cancellations`,
    businessHandleCancellation: (orderId) => `${SOCKET_BASE_API_URL}/order/${orderId}/handle-cancellation`,
    handleRefund: (orderId) => `${API_BASE_URL}/api/v1/order/${orderId}/handle-refund`,
    updateUser: (conversationId) => `${SOCKET_BASE_API_URL}/order/conversation/${conversationId}/update-user`,
    updateGroupOrderUser: (conversationId) => `${SOCKET_BASE_API_URL}/order/conversation/${conversationId}/update-group-order-user`,
    updateTableNumber: (conversationId) => `${SOCKET_BASE_API_URL}/order/conversation/${conversationId}/table-number`,
    getStatistics: (locationIds, params = {}) => {
      const baseUrl = `${SOCKET_BASE_API_URL}/order/statistics`;
      const locationIdsParam = Array.isArray(locationIds) 
        ? locationIds.join(',') 
        : locationIds;
      const queryParams = new URLSearchParams({
        locationIds: locationIdsParam,
        ...(params.dateRange && { dateRange: params.dateRange }),
        ...(params.startDate && { startDate: params.startDate }),
        ...(params.endDate && { endDate: params.endDate }),
      });
      return `${baseUrl}?${queryParams.toString()}`;
    },
    getSalesRefundsReturnsStatistics: (locationIds, dateRange, graphType) => {
      const baseUrl = `${SOCKET_BASE_API_URL}/order/sales-refunds-returns-statistics`;
      const locationIdsParam = Array.isArray(locationIds) 
        ? locationIds.join(',') 
        : locationIds;
      const queryParams = new URLSearchParams({
        locationIds: locationIdsParam,
        ...(dateRange && { dateRange }),
        ...(graphType && { graphType }),
      });
      return `${baseUrl}?${queryParams.toString()}`;
    },
    getLocationFollowers: (locationIds) => {
      const baseUrl = `${API_BASE_URL}/api/v1/business-location/followers-list`;
      const locationIdsParam = Array.isArray(locationIds)
        ? locationIds.join(",")
        : locationIds;
      return `${baseUrl}?locationIds=${locationIdsParam}`;
    },
  },

  DASHBOARD: {
    getDashboardStats: (locationIds) => {
      const ids = Array.isArray(locationIds) ? locationIds.join(",") : locationIds;
      return `${API_BASE_URL}/api/v1/dashboard/stats?locationIds=${ids}`;
    },
  },

  EVENT: {
    create: `${API_BASE_URL}/api/v1/event`,
    getMyEvents: (userId) => `${API_BASE_URL}/api/v1/event/my-events/${userId}`,
    get: `${API_BASE_URL}/api/v1/event`,
    update: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}`,
    delete: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}`,
    list: `${API_BASE_URL}/api/v1/event`,
    join: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/join`,
    leave: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/leave`,
    invite: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/invite`,
    eventCategory: `${API_BASE_URL}/api/v1/event-category`,
    // New invitation endpoints
    accept: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/accept`,
    showInterest: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/interest`,
    reject: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/reject`,
    invitationStatus: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/invitation-status`,
    invitations: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/invitations`,
    invitationList: (eventId) => `${API_BASE_URL}/api/v1/event/${eventId}/invitation/list`,
    invitationRequestList: `${API_BASE_URL}/api/v1/event/invitation/request/list`,
  },

  AI: {
    generateText: `${AI_BASE_URL}/chat`,
  },

  NOTIFICATION: {
    list: `${SOCKET_BASE_API_URL}/notifications`,
    markAsRead: (notificationId) => `${SOCKET_BASE_API_URL}/notifications/${notificationId}/read`,
    markAllAsRead: `${SOCKET_BASE_API_URL}/notifications/read-all`,
    clearAll: `${SOCKET_BASE_API_URL}/notifications/clear-all`,
  },

  REPORT: {
    subjects: (reportType) => `${API_BASE_URL}/api/v1/report/subject/${reportType}`,
    create: `${API_BASE_URL}/api/v1/report`,
  },

  UPLOAD: {
    presignedUrl: `${API_BASE_URL}/api/v1/upload/presigned-url`,
    confirm: `${API_BASE_URL}/api/v1/upload/confirm`,
    delete: (fileKey) => `${API_BASE_URL}/api/v1/upload/${encodeURIComponent(fileKey)}`,
  },
};
